import { useState, useEffect } from 'react';
import { CHROME_EXTENSION_ID } from '../config/constants';

declare global {
  interface Window {
    chrome?: {
      runtime?: {
        sendMessage?: (
          extensionId: string,
          message: unknown,
          callback: (response: unknown) => void
        ) => void;
      };
    };
  }
}

interface ExtensionDetectionResult {
  isInstalled: boolean | null;
  isChecking: boolean;
}

export function useExtensionDetection(): ExtensionDetectionResult {
  const [isInstalled, setIsInstalled] = useState<boolean | null>(null);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkExtension = () => {
      const extensionMarker = document.getElementById('govtoolspro-extension-marker');
      if (extensionMarker) {
        setIsInstalled(true);
        setIsChecking(false);
        return;
      }

      if (window.chrome?.runtime?.sendMessage) {
        try {
          window.chrome.runtime.sendMessage(
            CHROME_EXTENSION_ID,
            { type: 'PING' },
            (response) => {
              setIsInstalled(!!response);
              setIsChecking(false);
            }
          );
          setTimeout(() => {
            setIsChecking(prev => {
              if (prev) {
                setIsInstalled(false);
                return false;
              }
              return prev;
            });
          }, 1000);
        } catch {
          setIsInstalled(false);
          setIsChecking(false);
        }
      } else {
        setIsInstalled(false);
        setIsChecking(false);
      }
    };

    checkExtension();
  }, []);

  return { isInstalled, isChecking };
}
